import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  connectToParticipantDesktop,
  useSelectIsParticipantDesktopDeletePending,
  useSelectIsParticipantDesktopStartPending,
  useSelectIsParticipantDesktopStopPending,
  useSelectParticipantDesktopViewLink
} from 'Courses/data';
import { useAppDispatch } from 'Store';
import { openExternalUrl } from 'Utils/redirects';

import type { IConnectToParticipantDesktopRequest } from '@libs/models';

import { ConnectToDesktopButton } from './ConnectToDesktopBase';

type Props = {
  courseId: string;
  participantId: string;
  disabled?: boolean;
  isHighlighted: boolean;
  isMinimized: boolean;
};

export const ConnectToParticipantDesktopButton = ({
  courseId,
  participantId,
  disabled,
  isHighlighted,
  isMinimized
}: Readonly<Props>) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const isParticipantDesktopStartPending = useSelectIsParticipantDesktopStartPending(
    courseId,
    participantId
  );
  const isParticipantDesktopStopPending = useSelectIsParticipantDesktopStopPending(
    courseId,
    participantId
  );
  const isParticipantDesktopDeletePending = useSelectIsParticipantDesktopDeletePending(
    courseId,
    participantId
  );

  const participantDesktopViewLink = useSelectParticipantDesktopViewLink(courseId, participantId);

  const redirectToDesktop = (desktopLink: string) => openExternalUrl(desktopLink);

  const shouldNotRedirectToNewTab = true;

  const connectToDesktop = () =>
    dispatch(
      connectToParticipantDesktop({
        courseId,
        participantId
      } as IConnectToParticipantDesktopRequest)
    ).then(() => {
      !shouldNotRedirectToNewTab &&
        participantDesktopViewLink &&
        redirectToDesktop(participantDesktopViewLink);
    });

  return (
    <ConnectToDesktopButton
      buttonText={t('Connect')}
      onConnectToDesktopClick={connectToDesktop}
      disabled={disabled}
      isDesktopStartPending={isParticipantDesktopStartPending}
      isDesktopStopPending={isParticipantDesktopStopPending}
      isDesktopDeletePending={isParticipantDesktopDeletePending}
      isHighlighted={isHighlighted}
      isMinimized={isMinimized}
    />
  );
};
